var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-relative tw-bg-white",style:(_vm.colors)},[_vm._t("default"),_vm._t("footer",function(){return [_c('RegistryFooter',{attrs:{"section":_vm.sectionFooter}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }